<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="min(840px, calc(100vw - 32px))"
    append-to-body
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <p class="picker-hint">
      支持整省勾选或展开选择城市；灰色地区已归属其他规则，不会被覆盖。
    </p>
    <el-input
      v-model="keyword"
      placeholder="搜索省份或城市，例如浙江、杭州"
      clearable
      label="搜索省份或城市"
    />
    <div class="picker-actions">
      <el-button type="text" @click="batch(true)">全选当前可选地区</el-button>
      <el-button type="text" @click="batch(false)">清空当前可选地区</el-button>
    </div>
    <div class="freight-provinces">
      <div v-for="p in results" :key="p.id" class="province-row">
        <div class="province-head">
          <el-checkbox
            :value="count(p) === p.children.length"
            :indeterminate="count(p) > 0 && count(p) < p.children.length"
            :disabled="!available(p).length"
            @change="toggleProvince(p, $event)"
            >{{ p.name }}</el-checkbox
          >
          <span class="picker-hint"
            >已选 {{ count(p) }} / {{ p.children.length }}，可选
            {{ available(p).length }}</span
          >
          <el-button
            type="text"
            :aria-expanded="isOpen(p)"
            @click="$set(expanded, p.id, !isOpen(p))"
            >{{ isOpen(p) ? "收起" : "展开" }}</el-button
          >
        </div>
        <div v-if="isOpen(p)" class="province-cities">
          <label v-for="city in p.visible" :key="city.id" class="city-option">
            <el-checkbox
              :value="selected.includes(city.id)"
              :disabled="!!occupied[city.id]"
              @change="toggle([city.id], $event)"
              >{{ city.name }}</el-checkbox
            >
            <small v-if="occupied[city.id]">{{ occupied[city.id] }}</small>
          </label>
        </div>
      </div>
      <p v-if="!results.length" class="picker-hint">没有匹配的省份或城市</p>
    </div>
    <p aria-live="polite" class="picker-hint">
      已选择 {{ selected.length }} 个最小配送地区（省份勾选统计始终按整省计算）
    </p>
    <div class="picker-summary">{{ summary }}</div>
    <span slot="footer"
      ><el-button @click="$emit('close')">取消</el-button
      ><el-button type="primary" @click="$emit('confirm', selected.slice())"
        >确认选择</el-button
      ></span
    >
  </el-dialog>
</template>
<script>
import { searchRegions, compact } from "@/utils/freight-regions";
export default {
  props: {
    visible: Boolean,
    title: String,
    provinces: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    occupied: { type: Object, default: () => ({}) }
  },
  data() {
    return { keyword: "", selected: [], expanded: {} };
  },
  computed: {
    results() {
      return searchRegions(this.provinces, this.keyword);
    },
    summary() {
      return (
        compact(this.selected, this.provinces)
          .map(t => t.label)
          .join("、") || "尚未选择地区"
      );
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.selected = this.value.slice();
        this.keyword = "";
        this.expanded = {};
      }
    }
  },
  methods: {
    count(p) {
      return p.children.filter(c => this.selected.includes(c.id)).length;
    },
    available(p) {
      return p.children.filter(c => !this.occupied[c.id]);
    },
    isOpen(p) {
      return this.expanded[p.id] === undefined
        ? !!this.keyword.trim()
        : this.expanded[p.id];
    },
    toggle(ids, checked) {
      const next = new Set(this.selected);
      ids
        .filter(id => !this.occupied[id])
        .forEach(id => (checked ? next.add(id) : next.delete(id)));
      this.selected = Array.from(next);
    },
    // 省级复选框操作整省可选城市，搜索不会缩小它；批量按钮只操作搜索结果。
    toggleProvince(p, checked) {
      this.toggle(
        p.children.map(c => c.id),
        checked
      );
    },
    batch(checked) {
      this.toggle(
        this.results.reduce(
          (ids, p) => ids.concat(p.visible.map(c => c.id)),
          []
        ),
        checked
      );
    }
  }
};
</script>
<style scoped>
.picker-hint {
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
}
.picker-actions {
  display: flex;
  gap: 16px;
}
.freight-provinces {
  max-height: 390px;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}
.province-row + .province-row {
  border-top: 1px solid #ebeef5;
}
.province-head {
  display: flex;
  gap: 18px;
  align-items: center;
  padding: 4px 16px;
}
.province-head > .picker-hint {
  flex: 1;
}
.province-cities {
  padding: 12px 24px;
  background: #f8f9fc;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.city-option {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.city-option small {
  padding-left: 24px;
  color: #909399;
}
.picker-summary {
  max-height: 70px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.7;
  color: #606266;
}
@media (max-width: 800px) {
  .province-cities {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .province-head {
    flex-wrap: wrap;
  }
}
</style>
